import ufeApi from 'services/api/ufeApi';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Remove+Shipping+Address+from+Profile+API

function removeShippingAddress(profileId, addressId) {
    const url = `/gway/v2/users/profiles/${profileId}/address/${addressId}`;

    return ufeApi.makeRequest(url, { method: 'DELETE' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default removeShippingAddress;
